import { GlobalStyles } from 'twin.macro'
import { Global } from '@emotion/react'
import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import 'typeface-lato'
import 'typeface-roboto'
import 'typeface-roboto-mono'
import 'typeface-aleo'
import 'font-awesome/css/font-awesome.css'
import stylesBase from './stylesBase'
import './sass/app.scss'
import { useLocation } from '@reach/router' 
import { useCanonicalUrl } from '../utils/seo'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function TemplateWrapper({ children, title, description, image, enableIndexing }) {
  const location = useLocation()
  const url = `https://www.geocod.io${location.pathname}`;
  const canonicalUrl = useCanonicalUrl(location.pathname);

  const schema = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "url": url,
    "logo": "https://www.geocod.io/img/logo-full.svg",
    "sameAs": [
      "https://twitter.com/geocodio",
      "https://www.linkedin.com/company/geocodio/"
    ]
  };

  return (
    <div>
      <Helmet title={`${title} - Geocodio`}>
        <html lang="en" />
        {!enableIndexing && <meta name="robots" content="noindex" />}
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta http-equiv="content-type" content="text/html; charset=utf-8" />
        <meta name="author" content="Dotsquare LLC" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Geocodio" />
        <meta property="og:title" content={`${title} - Geocodio`} />
        <meta property="og:image" content={ image } />
        <meta property="og:url" content={url} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@geocodio" />
        <meta name="twitter:creator" content="@geocodio" />
        <link rel="canonical" href={canonicalUrl} />
        <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#e62b28" />
        <link rel="alternate" type="application/rss+xml" title="Geocodio Updates RSS Feed" href="/updates/rss.xml" />
        <link rel="alternate" type="application/rss+xml" title="Geocodio Code-and-Coordinates RSS Feed" href="/code-and-coordinates/rss.xml" />
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
        <script src="https://js.stripe.com/v3/" async></script>
      </Helmet>
      <GlobalStyles />
      <Global styles={stylesBase} />

      <Navbar />

      {children}

      <Footer />
    </div>
  );
}

TemplateWrapper.defaultProps = {
  description: 'Bulk geocode US and Canadian addresses and latitude/longitude coordinates via spreadsheet upload and API. Quickly and easily append Census data, ZIP+4, Congressional districts, timezones, and more.',
  image: 'https://www.geocod.io/img/social-share.png',
  enableIndexing: true
}

TemplateWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string,
  enableIndexing: PropTypes.bool,
}

export default TemplateWrapper
